import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Table, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core';

import Spinner from '../../components/UI/Spinner';
import ViewOrderHistoryForm from '../../components/Forms/ViewOrderHistoryForm';
import Aux from '../../hoc/NoParent';
import AjaxErrorMessage from '../../components/UI/AjaxErrorMessage';

import { loadOrdersFromServer } from '../../store/actions/index';
import { getServerFormattedDate, getISOFormattedDate } from '../../util/getFormattedDate';
import dataFormatter from '../../util/dataFormatter';
import { DescriptionOutlined } from '@material-ui/icons';

class OrderHistory extends Component {

    onSubmitForm = ({start, end}) => {
        this.props.loadOrdersFromServer(getServerFormattedDate(start), getServerFormattedDate(end), this.props.token);
    }

    onClickPaperworkHandler = (orderNumber) => {
        window.open(`${process.env.PUBLIC_URL}/lite/paperworks/view/${orderNumber}`, { target: '_blank' });
    }

    render() {
        const { loading, orders, error } = this.props;

        const date = new Date();

        let ordersGrid = loading ? <Spinner /> : null;

        if(!loading && orders !== null) {
            if(orders.length === 0) {
                ordersGrid = <p>No orders found for specified date range</p>
            }
            else {
                let i = 0;

                ordersGrid = <Table size="small" className="OrdersGrid">
                    <TableHead>
                        <TableRow className="Order">
                            <TableCell align='center' colSpan={2}>Order #</TableCell>
                            <TableCell className="Origin">Origin</TableCell>
                            <TableCell className="Destination">Destination</TableCell>
                            <TableCell className="StartDate">Start</TableCell>
                            <TableCell className="EndDate">End</TableCell>
                            <TableCell className="Miles">LD Miles</TableCell>
                            <TableCell className="Miles">MT Miles</TableCell>
                            <TableCell>Tot Miles</TableCell>
                            <TableCell>Settled</TableCell>
                            <TableCell>Trip Recap</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {orders.map(order => 
                            <TableRow key={i++} className="Order">
                                <TableCell><DescriptionOutlined title="View Paperwork" style={{ cursor: 'pointer' }} onClick={() => this.onClickPaperworkHandler(order.OrderNumbers)} /></TableCell>
                                <TableCell><Link to={`/loads/${order.LegNumber}`}>{order.OrderNumbers}</Link></TableCell>
                                <TableCell className="Origin">{order.Origin}</TableCell>
                                <TableCell className="Destination">{order.Destination}</TableCell>
                                <TableCell className="StartDate">{dataFormatter.toDate(order.StartDate, true)}</TableCell>
                                <TableCell className="EndDate">{dataFormatter.toDate(order.EndDate, true)}</TableCell>
                                <TableCell className="Miles" align="right">{dataFormatter.toNumber(order.LoadedMiles, 0)}</TableCell>
                                <TableCell className="Miles" align="right">{dataFormatter.toNumber(order.EmptyMiles, 0)}</TableCell>
                                <TableCell align="right">{dataFormatter.toNumber(+order.LoadedMiles + +order.EmptyMiles, 0)}</TableCell>
                                <TableCell>{order.LegIsSettled}</TableCell>
                                <TableCell>{order.TripRecapReceived}</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            }
        }

        return (
            <Aux>
                <ViewOrderHistoryForm initialValues={{start: getISOFormattedDate(date.setDate(date.getDate() -30)), end: getISOFormattedDate(new Date())}} onSubmit={this.onSubmitForm} />
                <div style={{overflow: 'auto'}}>
                {ordersGrid}
                </div>
                <AjaxErrorMessage error={error} />
            </Aux>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        orders: state.order.orders, 
        token: state.auth.token, 
        loading: state.order.loading, 
        error: state.order.error
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadOrdersFromServer: (start, end, token) => dispatch(loadOrdersFromServer(start, end, token))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderHistory);